// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { WarningStatusIcon } from '@/constants/hardfin-standard-icons';
import { Chip } from '@mui/material';
import { DateTime } from 'luxon';

interface Props {
  // When the provider stopped reporting the shipment; null while it reports it
  missingSince: DateTime | null;

  // Whether a provider holds the shipment
  thirdPartyBound: boolean;
}

/**
 * Warning chip for a shipment its provider stopped reporting.
 */
export function MissingShipmentChip(props: Props) {
  if (props.missingSince === null) {
    return null;
  }

  return (
    <Chip
      size="small"
      color="warning"
      icon={<WarningStatusIcon />}
      label={props.thirdPartyBound ? 'Missing from 3PL' : 'Missing'}
    />
  );
}
